module.exports = __webpack_public_path__ + "static/media/mw.c92079dc.svg";